import { render, staticRenderFns } from "./NotAuthLayout.vue?vue&type=template&id=6ccc8a45&scoped=true&"
import script from "./NotAuthLayout.vue?vue&type=script&lang=js&"
export * from "./NotAuthLayout.vue?vue&type=script&lang=js&"
import style0 from "./NotAuthLayout.vue?vue&type=style&index=0&id=6ccc8a45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc8a45",
  null
  
)

export default component.exports